import React from 'react';
import './DashboardAppSection.scss';
import { PropTypes } from 'prop-types';
import HrbTranslate from "../language/HrbTranslate";
import ExternalLink from "../link/ExternalLink";

const DashboardAppSection = (props) => (
    <div className="hrb-dashboard-app-section-container">
        <div className="hrb-dashboard-app-section-heading">
          {props.img ? props.img : null }
          <div className="hrb-dashboard-app-section-heading-text">
            <HrbTranslate text={props.header}/>
          </div>
          {props.sectionHelpLink &&
          <div className="hrb-dashboard-app-section-heading-help">
            <ExternalLink textKey="dashboard.whats_this" linkKey={props.sectionHelpLink} isNewWindow={true}/>
          </div>
          }

        </div>

      {props.children}
    </div>
);

DashboardAppSection.propTypes = {
  header: PropTypes.string,
  sectionHelpLink: PropTypes.string,
  img: PropTypes.element
};

export default DashboardAppSection;